import Aos from "aos";
import React, { useEffect } from "react";

function Team(props) {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  });
  return (
    <div className="flex w-full flex-col md:flex-row justify-between p-10 md:p-20">
      <div className="lg:w-1/3 w-full">
        <h1
          data-aos="zoom-in"
          className="text-slate-400 text-2xl md:text-[40px] lg:text-[60px] font-bold mt-5"
        >
          Who are we?
        </h1>
        <h1
          data-aos="zoom-out"
          className="text-2xl md:text-[40px] mt-5 align-right text-transparent bg-clip-text bg-gradient-to-r from-[#d02561] to-[#ff79a8]"
        >
          Creative teams
        </h1>
      </div>
      <div className="lg:w-2/3 w-full md:px-20">
        <p data-aos="zoom-out-right" className="text-slate-400">
          Gele is a collection of hand-drawn randomized art inspired by
          elaborately stylized head-ties worn by women in West Africa. These
          extravagant head-ties are often made from ornate material and often
          symbolize status in one’s community. Tying a gele is a process that
          requires the help of another skilled individual as the tie becomes
          more grand and intricate. Historically, a stiff damask fabric with a
          contrasting luster has been used for geles. Currently, a wider variety
          of fabric types are used in the tying of creatively styled geles.
        </p>
      </div>
    </div>
  );
}

export default Team;
